/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type UserPermissionsItem = (typeof UserPermissionsItem)[keyof typeof UserPermissionsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPermissionsItem = {
  app_access: "app_access",
  licensed_investment_advisor: "licensed_investment_advisor",
} as const;
